import { SignOut as AWSSignOut } from 'aws-amplify-react';
import React from 'react';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

export default class SignOut extends AWSSignOut {
  render() {
    const { listItemClass, listItemTextClass, listIcon } = this.props;
    const superRendering = super.render();

    if (!superRendering) {
      return null;
    }

    return (
      <ListItem button className={listItemClass} onClick={this.signOut}>
        <ListItemIcon className={listIcon}>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Sign Out" className={listItemTextClass} />
      </ListItem>
    );
  }
}
